import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { FieldKey } from '@atlassian/jira-polaris-domain-field/src/field/types.tsx';

export const deleteField = (projectId: string, fieldKey: FieldKey): Promise<void> =>
	performDeleteRequest(`/rest/polaris/v2/projects/${projectId}/fields/${fieldKey}`);
